itsoftApp.createModule("accordion", function() {
    var module = this;

    var initAccordions = function (accordion) {
        var accordionHeadElements = accordion.querySelectorAll(".js-accordion-head");

        Array.prototype.forEach.call(accordionHeadElements, function (el) {
            el.addEventListener("click", function (evt) {
                evt.preventDefault();

                var self = this;
                var activeHead;
                var currentHead;

                // стили находятся в файле assets/styles/page.styl

                var closeAccordion = function (el) {
                    if (self.classList.contains("js-accordion-head--parent")) {
                        // находим родителя активного элемента
                        var parent = el;
                        var accordionItem = el.closest(".js-accordion-item");
                        var nextElement = parent.nextElementSibling;
                        // добавляем класс для анимации отображения/скрытия
                        parent.classList.add("js-accordion-parent--ready");
                        var height = nextElement.clientHeight + "px";
                        nextElement.style.height = height;

                        var onTransitionEnd = function () {
                            // удаляем у активного элемента активный класс
                            activeHead.classList.remove("js-accordion-head--active");
                            accordionItem.classList.remove("js-accordion-item--active");
                            // у родителя тоже
                            parent.classList.remove("js-accordion-parent--active");
                            parent.classList.remove("js-accordion-parent--ready");
                            nextElement.removeEventListener("transitionend", onTransitionEnd);
                        }

                        nextElement.addEventListener("transitionend", onTransitionEnd);

                        requestAnimationFrame(function () {
                            requestAnimationFrame(function () {
                                // добавляем для соседнего элемента с контентом нулевую высоту
                                nextElement.style.height = "0px";
                            })
                        });
                    } else {
                        var nextElement = activeHead.nextElementSibling;
                        var accordionItem = activeHead.closest(".js-accordion-item");
                        activeHead.classList.add("js-accordion-head--ready");
                        var height = nextElement.clientHeight + "px";
                        nextElement.style.height = height;

                        var onTransitionEnd = function () {
                            accordionItem.classList.remove("js-accordion-item--active");
                            activeHead.classList.remove("js-accordion-head--ready");
                            activeHead.classList.remove("js-accordion-head--active");
                            nextElement.removeEventListener("transitionend", onTransitionEnd);
                        };

                        nextElement.addEventListener("transitionend", onTransitionEnd);

                        requestAnimationFrame(function () {
                            requestAnimationFrame(function () {
                                nextElement.style.height = "0px";
                            });
                        });
                    }
                }

                var openAccordion = function (el) {
                    if (self.classList.contains("js-accordion-head--parent")) {
                        var parent = el;
                        var accordionItem = el.closest(".js-accordion-item");
                        var nextElement = el.nextElementSibling;
                        currentHead.classList.add("js-accordion-head--active");
                        parent.classList.add("js-accordion-parent--active");
                        accordionItem.classList.add("js-accordion-item--active");
                        nextElement.style.height = "auto";
                        var height = nextElement.clientHeight + "px";
                        nextElement.style.height = "0px";
                        requestAnimationFrame(function () {
                            requestAnimationFrame(function () {
                                nextElement.style.height = height;
                            });
                        });
                    } else {
                        var nextElement = currentHead.nextElementSibling;
                        var accordionItem = currentHead.closest(".js-accordion-item");
                        currentHead.classList.add("js-accordion-head--active");
                        accordionItem.classList.add("js-accordion-item--active");
                        nextElement.style.height = "auto";
                        var height = nextElement.clientHeight + "px";
                        nextElement.style.height = "0px";
                        requestAnimationFrame(function () {
                            requestAnimationFrame(function () {
                                nextElement.style.height = height;
                            });
                        });
                    }
                }

                // Если элемент, на котором произошло событие, имеет класс js-accordion-head--parent
                if (this.classList.contains("js-accordion-head--parent")) {
                    // Если этот элемент был уже активен
                    if (this.classList.contains("js-accordion-head--active")) {
                        activeHead = self;
                        var activeParent = activeHead.closest(".js-accordion-parent");
                        closeAccordion(activeParent);
                        accordion.classList.remove("js-accordion--active");
                    } else {
                        activeHead = accordion.querySelector(".js-accordion .js-accordion-head--active");

                        if (activeHead) {
                            var activeParent = activeHead.closest(".js-accordion-parent");
                            closeAccordion(activeParent);
                        }
                        currentHead = self;

                        var currentParent = currentHead.closest(".js-accordion-parent");
                        openAccordion(currentParent);
                        accordion.classList.add("js-accordion--active");
                    }
                } else {
                    // Если этот элемент был уже активен
                    if (this.classList.contains("js-accordion-head--active")) {
                        activeHead = self;
                        closeAccordion();
                        accordion.classList.remove("js-accordion--active");
                    } else {
                        activeHead = accordion.querySelector(".js-accordion .js-accordion-head--active");

                        if (activeHead) {
                            closeAccordion();
                        }

                        currentHead = self;
                        openAccordion();
                        accordion.classList.add("js-accordion--active");
                    }
                }
            });
        });
    }

    module.callback = initAccordions;
})